import { render, staticRenderFns } from "./CodeLogin.vue?vue&type=template&id=6af5208f&scoped=true&"
import script from "./CodeLogin.vue?vue&type=script&lang=js&"
export * from "./CodeLogin.vue?vue&type=script&lang=js&"
import style0 from "./CodeLogin.vue?vue&type=style&index=0&id=6af5208f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af5208f",
  null
  
)

export default component.exports